import { Box, Typography, CheckCircleOutlinedIcon, CancelOutlinedIcon, AccountCircleOutlinedIcon } from "src/components"
import { useParams } from "react-router-dom"

export default function PaymentStatusPage() {
  const { status } = useParams()

  let icon = null
  let heading = ""
  let description = ""

  switch (status) {
    case "payment-success":
      icon = <CheckCircleOutlinedIcon sx={{ fontSize: 100, color: "success.main" }} />
      heading = "Payment Successful!"
      description =
        "Welcome to the family 🎉 Your premium features are now active. You might need to refresh to start exploring your new capabilities."
      break

    case "payment-cancelled":
      icon = <CancelOutlinedIcon sx={{ fontSize: 100, color: "error.main" }} />
      heading = "Payment Cancelled"
      description =
        "Your payment was cancelled and you haven't been charged. You can try again anytime to unlock premium features."
      break

    case "portal-return":
      icon = <AccountCircleOutlinedIcon sx={{ fontSize: 100, color: "primary.main" }} />
      heading = "Billing Portal"
      description =
        "You've successfully returned from the billing portal. Your subscription settings have been updated and you can manage them anytime."
      break

    default:
      icon = <CancelOutlinedIcon sx={{ fontSize: 100, color: "error.main" }} />
      heading = "Invalid Status"
      description = "We couldn't recognize this payment status. Please check your URL or try again."
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      textAlign="center"
      px={2}
      maxWidth="600px"
      mx="auto"
    >
      {icon}

      <Typography
        variant="h3"
        component="h1"
        sx={{
          mt: 3,
          mb: 2,
          fontWeight: 600,
          fontSize: { xs: "1.75rem", sm: "2.125rem" },
        }}
      >
        {heading}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 3,
          color: "text.secondary",
          fontSize: "1.125rem",
          lineHeight: 1.6,
          maxWidth: "500px",
        }}
      >
        {description}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontSize: "0.875rem",
        }}
      >
        Having issues? Contact our support team for assistance at panamexplorer@gmail.com
      </Typography>
    </Box>
  )
}
